import { render, staticRenderFns } from "./detail-virtualaccount.vue?vue&type=template&id=2ed87728&"
import script from "./detail-virtualaccount.vue?vue&type=script&lang=js&"
export * from "./detail-virtualaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports